import { authService } from "../utils/authService";
import { errorHandler } from "../components/shared/errorhandler";
import { IUserAccessDetails, ISessionConfig } from "./App.interface";

export const fetchUserAccessDetails = async (
  isPaymentSuccessPage: boolean,
): Promise<IUserAccessDetails> => {
  // Phase 1: Call local server (was Studio gateway)
  return fetch(`/api/user/${isPaymentSuccessPage}`, {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};

export const getInstanceSessionDefault = async (): Promise<ISessionConfig> => {
  // Phase 1: Call local server (was Studio gateway)
  return fetch("/api/v1/session-config", {
    headers: await authService.getAuthorizationHeader(),
  })
    .then(errorHandler)
    .then((response) => response.json());
};
